export var SegmentType;
(function (SegmentType) {
    SegmentType[SegmentType["MOVE"] = 0] = "MOVE";
    SegmentType[SegmentType["LINE"] = 1] = "LINE";
    SegmentType[SegmentType["POLYLINE"] = 2] = "POLYLINE";
    SegmentType[SegmentType["ARC"] = 3] = "ARC";
    SegmentType[SegmentType["CUBIC"] = 4] = "CUBIC";
    SegmentType[SegmentType["QUADRATIC"] = 5] = "QUADRATIC";
    SegmentType[SegmentType["CLOSE"] = 6] = "CLOSE";
})(SegmentType || (SegmentType = {}));
